import React from "react";
import { Spinner } from "../_components";

const Callback = () => {
  return <Spinner message={"Authenticating"} />;
};

export default Callback;
